export default __webpack_public_path__ + "static/iPhoneCutout-a19363ea10ab3f4fe905284ba9ce817b.webp";